// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-splitter-layout/lib/index.css
// module id = 806
// module chunks = 1